import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgCalendarOutline = function SvgCalendarOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.25C8.41421 2.25 8.75 2.58579 8.75 3V4.25H15.75V3C15.75 2.58579 16.0858 2.25 16.5 2.25C16.9142 2.25 17.25 2.58579 17.25 3V4.25H18.5C20.0188 4.25 21.25 5.48122 21.25 7V18.5C21.25 20.0188 20.0188 21.25 18.5 21.25H6C4.48122 21.25 3.25 20.0188 3.25 18.5V7C3.25 5.48122 4.48122 4.25 6 4.25H7.25V3C7.25 2.58579 7.58579 2.25 8 2.25ZM6 5.75C5.30964 5.75 4.75 6.30964 4.75 7V9.25H19.75V7C19.75 6.30964 19.1904 5.75 18.5 5.75H6ZM19.75 10.75H4.75V18.5C4.75 19.1904 5.30964 19.75 6 19.75H18.5C19.1904 19.75 19.75 19.1904 19.75 18.5V10.75Z"
  })));
};

export { SvgCalendarOutline as ReactComponent };
//# sourceMappingURL=calendar-outline.svg.js.map
